<template>
  <page-layout title="게시판 관리">
    <template v-slot:table>
      <board-manage-table
        :data="data"
        :loading="loading"
        @refresh="refreshData"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import CategoryManageTable from "@/pages/Board/components/CategoryMange/CategoryManageTable.vue";
import {mapGetters} from "vuex";
import {axiosInstance} from "@/util/AxiosModule";

export default {
  name: "CategoryMange",
  components: {BoardManageTable: CategoryManageTable, PageLayout},
  data() {
    return {
      data: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId"
    })
  },
  mounted() {
    this.getBoardCategory();
  },
  methods: {
    async getBoardCategory() {
      try {
        const { data } = await axiosInstance.get("/private/board/category", {
          params: {
            memberId: this.memberId,
            useYn: ""
          }
        });
        if (data.length < 1) {
          this.data = [];
          return false;
        } else {
          this.data = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    refreshData() {
      this.getBoardCategory();
    }
  }
}
</script>